import lodash from 'lodash'
import React, { Component, Fragment } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import styled from 'styled-components'
import { v4 as uuid } from 'uuid'

import Address from '../../../../1stlog-ui/src/components/Address'
import Placeholder from '../../../../1stlog-ui/src/components/Placeholder'

const ItemWrapper = styled.div`
  cursor: pointer;
`

class Item extends Component {
  onSelect = () => {
    const { address, onSelect } = this.props
    onSelect(address)
  }

  render() {
    const { address, isSelected } = this.props
    return (
      <ItemWrapper
        className={`list-group-item ${
          isSelected ? 'list-group-item-primary' : ''
        }`}
        onClick={this.onSelect}
      >
        <Address {...address} />
      </ItemWrapper>
    )
  }
}

class Loader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: 0,
    }
    this.id = uuid()
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.isOpen && nextProps.isOpen) {
      this.setState({ selectedIndex: 0 }, () => {
        setTimeout(() => document.getElementById(this.id).focus(), 1)
      })
    }
  }

  onSelect = (address) => {
    const { onSelect, update, onHide } = this.props
    onSelect(address)
    onHide()
  }

  move = (amount) => {
    const { addresses } = this.props
    const { selectedIndex } = this.state
    const len = lodash.get(addresses, 'length', 0)
    const target = selectedIndex + amount
    let nextIndex = 0
    if (target + 1 > len) {
      nextIndex = len - 1
    } else if (target < 1) {
    } else {
      nextIndex = target
    }
    this.setState({ selectedIndex: nextIndex })
  }

  onKeyUp = (e) => {
    const { addresses, onSelect, isOpen, onHide } = this.props
    const { selectedIndex } = this.state
    if (isOpen) {
      e.stopPropagation()
    } else {
      return
    }
    if (e.key === 'Escape') {
      onHide()
    }
    if (e.key === 'ArrowUp') {
      this.move(-1)
    }
    if (e.key === 'ArrowDown') {
      this.move(1)
    }
    if (e.key === 'Enter' && !e.ctrlKey) {
      const len = lodash.get(addresses, 'length', 0)
      // if (len === 0) {
      //   onSelect()
      // }
      if (len >= selectedIndex + 1) {
        onSelect(addresses[selectedIndex])
      }
    }
  }

  render() {
    const { isOpen, addresses, title, onHide } = this.props
    const { selectedIndex } = this.state
    const hasResults = lodash.get(addresses, 'length', 0) > 0
    // console.log('render', this.props)
    return (
      <Modal isOpen={isOpen} toggle={onHide}>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          {!hasResults ? (
            <Placeholder>{i18n.t('no_results', 'Keine Ergebnisse')}</Placeholder>
          ) : (
            <div>
              <p>
                {i18n.t('click_on_address_or_use_arrowbutton', 'Klicken Sie auf eine Adresse oder verwenden Sie die Pfeiltasten und bestätigen mit Enter, um diese zu übernehmen.')}
              </p>
            </div>
          )}
          <div
            id={this.id}
            tabIndex="0"
            className="list-group list-group-flusha"
            onKeyDown={this.onKeyUp}
          >
            {(addresses || []).map((item, index) => (
              <Item
                address={item}
                key={index}
                isSelected={selectedIndex === index}
                onSelect={this.onSelect}
              />
            ))}
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

export default Loader
